import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { ShoppingBag } from "@phosphor-icons/react";
import { api } from "@/lib/api";
import Logo from "@/components/Logo";
import PurchaseRecCard from "@/components/PurchaseRecCard";

export default function ShopPage() {
  const [items, setItems] = useState([]);
  const navigate = useNavigate();

  useEffect(() => {
    api.get("/projects").then((r) => {
      const projects = r.data || [];
      const flat = [];
      for (const p of projects) {
        // we need materials; fetch each detail
      }
      // batch fetch project details
      Promise.all(projects.map((p) => api.get(`/projects/${p.id}`))).then((details) => {
        const all = [];
        for (const d of details.map((x) => x.data)) {
          for (const m of d.materials || []) {
            if (m.status === "need_to_buy") {
              all.push({ ...m, project_id: d.id, project_title: d.title });
            }
          }
        }
        setItems(all);
      });
    });
  }, []);

  const markBought = async (mId) => {
    await api.patch(`/projects/materials/${mId}`, { status: "bought" });
    setItems((arr) => arr.filter((x) => x.id !== mId));
  };

  return (
    <div className="min-h-screen pb-32" data-testid="shop-page">
      <header className="px-5 pt-6 pb-3 max-w-md mx-auto w-full">
        <Logo />
        <h1 className="font-heading text-3xl font-bold mt-3">Shop list</h1>
        <p className="text-sm text-timber-700">Everything you still need across projects.</p>
      </header>
      <main className="px-5 max-w-md mx-auto w-full space-y-3">
        {items.length === 0 ? (
          <div className="tactile-card p-6 text-center">
            <ShoppingBag size={40} weight="duotone" className="mx-auto text-timber-500" />
            <p className="text-timber-900 font-bold mt-2">Nothing to buy</p>
            <p className="text-sm text-timber-700 mt-1">You're stocked. Get back to it.</p>
          </div>
        ) : items.map((m) => (
          <div key={m.id} className="tactile-card p-4" data-testid={`global-shop-row-${m.id}`}>
            <p className="label-cap">{m.project_title}</p>
            <div className="flex items-start justify-between gap-2 mt-1">
              <div className="min-w-0 flex-1">
                <p className="font-heading text-lg font-bold">
                  {m.name}{m.quantity && <span className="text-timber-500 font-normal text-base"> · {m.quantity}</span>}
                </p>
              </div>
              <button
                data-testid={`global-mark-bought-${m.id}`}
                onClick={() => markBought(m.id)}
                className="bg-ok text-white rounded-xl px-3 py-2 font-bold text-sm btn-press shadow-tactile"
              >
                Bought
              </button>
            </div>
            {m.purchase_suggestion && (
              <div className="mt-2">
                <PurchaseRecCard suggestion={m.purchase_suggestion} compact />
              </div>
            )}
            <button
              onClick={() => navigate(`/projects/${m.project_id}`)}
              className="text-xs text-denim font-bold mt-2"
            >
              Open project →
            </button>
          </div>
        ))}
      </main>
    </div>
  );
}
